import { Grid, useMediaQuery, useTheme } from "@mui/material";
import MobileHeaderSecondary from "../../features/header/mobileHeaderSecondary/mobileHeaderSecondary";
import SecondaryHeader from "../../features/header/secondaryHeader/secondaryHeader";
import SubHeader from "../../features/header/subHeader/subHeader";
import { useAdvertisementRequestPageStyles } from "./advertisementRequestPageStyles";
import AdvertisementRequestSection from "../../features/advertisementRequestSection/advertisementRequestSection";
import { colors } from "../../app/theme/colors";

export default function AdvertisementRequestPage() {
  const { classes } = useAdvertisementRequestPageStyles();
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <>
      <SubHeader />
      {isDesktop && <SecondaryHeader />}
      {isMobile && <MobileHeaderSecondary />}
      <div className={classes.container}>
        <Grid
          item
          md={12}
          xs={12}
          style={{ backgroundColor: colors.subHeader }}
        >
          <AdvertisementRequestSection />
        </Grid>
      </div>
    </>
  );
}
